import { render, staticRenderFns } from "./class_record_all.vue?vue&type=template&id=4c13a04a&scoped=true"
import script from "./class_record_all.vue?vue&type=script&lang=js"
export * from "./class_record_all.vue?vue&type=script&lang=js"
import style0 from "./class_record_all.vue?vue&type=style&index=0&id=4c13a04a&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c13a04a",
  null
  
)

export default component.exports